import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';


import { processLogout } from 'common/helpers/auth'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function AccountSettingsHead() {
  const classes = useStyles();

  return (
    <div className = {classes.root}>
      <AppBar position="static" >
        <Toolbar>

          <Typography className={classes.title}>
            Settings 
          </Typography>
          <Button onClick={processLogout} color="inherit">Logout</Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}


 
